import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { threadId } from 'worker_threads';
import { JobTypes } from '../models/globals';

@Injectable({
  providedIn: 'root',
})

export class NavigationService {
  constructor(private dialog: MatDialog) {}

  private deploymentName = new BehaviorSubject<string>('');
  public DeploymentName = this.deploymentName.asObservable(); // contains deployment name

  public selectedLogType: string = null;

  sendDeploymentName(depName: string) {
    this.deploymentName.next(depName);
  }

  private selectedIdx = new BehaviorSubject<number>(0);
  public index = this.selectedIdx.asObservable(); // contains index of left panel

  sendLeftPanelIndex(index: number) {
    this.selectedIdx.next(index);
  }

  private BreadcrumbEntity = new BehaviorSubject<string>('');
  public breadcrumbEntity = this.BreadcrumbEntity.asObservable(); // contains active entity name shown at breadcrumb

  subNavData(name: string) {
    if(name == null || name == "") return;
    this.BreadcrumbEntity.next(name);
  }

  getCurrentEntity(){
    return this.BreadcrumbEntity.value
  }

  private BreadcrumbDeployment = new BehaviorSubject<string>('');
  public breadcrumbDeployment = this.BreadcrumbDeployment.asObservable(); // contains deployment name which is shown in breadcrumb

  sendChildData(text: string) {
    if (text != '') {
      this.BreadcrumbDeployment.next(text);
    }
  }

  getCurrentDeployment(){
    return this.BreadcrumbDeployment.value;
  }

  private BreadcrumbActiveProperty = new BehaviorSubject<string>('');
  public breadcrumbActiveProperty = this.BreadcrumbActiveProperty.asObservable(); // contain active property name shown at breadcrumb

  sendParentData(name: string) {
    this.BreadcrumbActiveProperty.next(name);
  }

  getParenDataValue(){
    return this.BreadcrumbActiveProperty.value;
  }

  private LastUpdateTime = new BehaviorSubject<Date>(new Date());
  public lastUpdateTime = this.LastUpdateTime.asObservable(); // contains last update/refresh time of component/data

  sendLastUpdate(date: Date) {
    this.LastUpdateTime.next(date);
  }

  private cloud = new BehaviorSubject<string>('');
  public Cloud = this.cloud.asObservable(); // to check if the cloud is onPremise

  sendCloud(value: string) {
    this.cloud.next(value);
  }


  // check minimize components
  returnMinimizeId(dialogId: string){
    switch (dialogId) {
      case JobTypes.Abaqus:
        return "addNewJobDialogAbaqus";
      case JobTypes.Command:
        return "addNewJobDialogCommand";
      case JobTypes.Cfx:
        return "addNewJobDialogCfx";
      case JobTypes.Starccm:
        return "addNewJobDialogStarccm";
      case JobTypes.Fluent:
        return "addNewJobDialogFluent";
      case JobTypes.Mechanical:
        return "addNewJobDialogMech";
      case JobTypes.Lsdyna:
        return "addNewJobDialogLsdyna";
      case JobTypes.Converge:
        return "addNewJobDialogConverge";
      case JobTypes.Actran:
        return "addNewJobDialogActran";
      case JobTypes.Nastran:
        return "addNewJobDialogNastran";
      case JobTypes.Optistruct:
        return "addNewJobDialogOptistruct";
      case JobTypes.Optis:
        return "addNewJobDialogOptis";
      case JobTypes.Radioss:
        return "addNewJobDialogRadioss";
      case JobTypes.Hfss:
        return "addNewJobDialogHfss";
      case JobTypes.Fluidx:
        return "addNewJobDialogFluidx";
      case JobTypes.DynamicJob:
        return "addNewJobDialogDynamic";
      case "Terminal":
        return "terminalDialog"
      case "OutputDialogStorage":
        return "jobOutputDialogStorage"
      case "OutputDialogJobs":
        return "jobOutputDialogJobs"
      default: 
        return null;
    }
  }

  closeOpenedDialogs() {
    let openDialogs = this.dialog.openDialogs;
    if (openDialogs.length > 0) {
      openDialogs.forEach(dialog => {
        if (!dialog.id?.startsWith('addNewJobDialog')) {
          dialog.close();
        }
      });
    }
  }

  async checkIfDialogIsAlreadyOpen(dialogName: string){
    return new Promise((resolve, reject) => {
      let openDialogs = this.dialog.openDialogs;
      let id = this.returnMinimizeId(dialogName);
      if(openDialogs.length > 0) {
        openDialogs.forEach(dialog => {
          if(dialog.id == id){
            this.dialog.getDialogById(id).componentInstance.toogleDialog = false;
            document.getElementById(id).classList.remove('minimize', 'minimize2')
            resolve(true);
          }
        });
      }
      resolve(false);
    })
  }
}
